import type { Notification } from "@/api/notifications";

/** Spec D11: agent comments and assignments live in the bell and the task
 *  board only — no toast, no macOS notification, no sound, no tray badge. */
const QUIET_NOTIFICATION_TYPES: ReadonlySet<Notification["notification_type"]> = new Set([
  "task_comment",
  "task_assigned",
]);

export function isQuietNotification(
  notification: Pick<Notification, "notification_type">,
): boolean {
  return QUIET_NOTIFICATION_TYPES.has(notification.notification_type);
}
